import { Season } from '../../../../corelogic/domain/models/season.model';
import { getAuthenticationToken } from '../../../../corelogic/state/authentication/authentication.selector';
import { getSeasons } from '../../../../corelogic/state/season/season.selector';
import { store } from '../../../../corelogic/state/store';
import {
  retrieveFighterFrequencyBySeason,
  retrieveUsersTotalPointsBySeason,
} from '../../../../corelogic/state/userSeason/userSeason.action';
import {
  getUserSeasonFighterFrequencySeasonId,
  getUserSeasonUsersTotalPointsSeasonId,
} from '../../../../corelogic/state/userSeason/userSeason.selector';

export const UserSeasonStatsService = {
  isSeasonValid: (seasonId: string): boolean => {
    const seasons = getSeasons(store.getState());
    if (!seasons || seasons.length === 0) {
      console.warn('UserSeasonService: No seasons loaded');
      return false;
    }

    const selectedSeasonData = seasons.find(
      (season: Season) => season.seasonId === seasonId,
    );

    if (!selectedSeasonData) {
      console.warn(`UserSeasonService: Season ${seasonId} not found`);
      return false;
    }

    return true;
  },

  retrieveFighterFrequencyBySeason: (seasonId: string) => {
    console.log('UserSeasonStatsService: retrieveFighterFrequencyBySeason');
    const token = getAuthenticationToken(store.getState());
    if (!token) {
      console.warn('UserSeasonService: No authentication token found');
      return;
    }

    if (!UserSeasonStatsService.isSeasonValid(seasonId)) {
      console.warn(`UserSeasonService: Season ${seasonId} not valid`);
      return;
    }

    const currentSeasonId = getUserSeasonFighterFrequencySeasonId(
      store.getState(),
    );
    if (currentSeasonId === seasonId) {
      console.warn(`UserSeasonStatsService: Season ${seasonId} already loaded`);
      return;
    }

    store.dispatch(
      retrieveFighterFrequencyBySeason({
        token,
        seasonId,
        retry: 0,
      }),
    );
  },

  retrieveUsersTotalPointsBySeason: (seasonId: string, limit: number = 10) => {
    const token = getAuthenticationToken(store.getState());
    if (!token) {
      console.warn('UserSeasonService: No authentication token found');
      return;
    }

    if (!UserSeasonStatsService.isSeasonValid(seasonId)) {
      console.warn(`UserSeasonService: Season ${seasonId} not valid`);
      return;
    }

    const currentSeasonId = getUserSeasonUsersTotalPointsSeasonId(
      store.getState(),
    );
    if (currentSeasonId === seasonId) {
      console.warn(`UserSeasonStatsService: Season ${seasonId} already loaded`);
      return;
    }

    store.dispatch(
      retrieveUsersTotalPointsBySeason({
        token,
        seasonId,
        retry: 0,
        limit,
      }),
    );
  },
};
